/* eslint-disable no-undef */
const API_BASE_URL = JSON.parse(process.env.REACT_APP_API_URL_MAP)[
  window.location.host
];

const defaultHeaders = {
  "Content-type": "application/json"
};

// eslint-disable-next-line import/prefer-default-export
export const ApiService = {
  post: async (url, data, headers) => {
    const fullUrl = /^https?:\/\//.test(url) ? url : `${API_BASE_URL}/${url}`;
    const response = await fetch(fullUrl, {
      method: "POST",
      headers: {
        ...defaultHeaders,
        ...headers
      },
      body: JSON.stringify(data)
    });
    return response.json();
  },
  patch: async (url, data, headers) => {
    const fullUrl = /^https?:\/\//.test(url) ? url : `${API_BASE_URL}/${url}`;
    const response = await fetch(fullUrl, {
      method: "PATCH",
      headers: {
        ...defaultHeaders,
        ...headers
      },
      body: JSON.stringify(data)
    });
    return response.json();
  },
  get: async (url, headers) => {
    const fullUrl = /^https?:\/\//.test(url) ? url : `${API_BASE_URL}/${url}`;
    const response = await fetch(fullUrl, {
      method: "GET",
      headers: {
        ...defaultHeaders,
        ...headers
      }
    });
    return response.json();
  },
  delete: async (url, headers) => {
    const fullUrl = /^https?:\/\//.test(url) ? url : `${API_BASE_URL}/${url}`;
    const response = await fetch(fullUrl, {
      method: "DELETE",
      headers: {
        ...defaultHeaders,
        ...headers
      }
    });
    return response.json();
  }
};
